import { IUserPromoCode } from 'types/user-promo-code.types';

const REFERRAL_ERROR_CODE_PREFIX = 'REFERRAL_';

// Mirrors the amount-off types in yaga-shared PROMO_CODE_TYPE. Free delivery, commission-free and
// attribution codes also carry an amount (often 100 percent) that means something else.
const AMOUNT_OFF_TYPES = ['product_price_discount', 'delivery_fee_discount', 'buyer_protection_fee_discount'];

export const isReferralErrorCode = (errorCode: string | undefined): errorCode is string =>
  !!errorCode?.startsWith(REFERRAL_ERROR_CODE_PREFIX);

export const hasPromoCodeAmount = ({ type, amount }: Pick<IUserPromoCode, 'type' | 'amount'>): boolean =>
  !!type && AMOUNT_OFF_TYPES.includes(type) && amount != null && Number(amount) > 0;

// `undefined` is an older API that does not send displayCode; null means the holder never typed a code.
export const getShownCode = ({ code, displayCode }: Pick<IUserPromoCode, 'code' | 'displayCode'>): string | null =>
  displayCode === undefined ? code : displayCode;

const PENDING_REFERRAL_CODE_KEY = 'referralCode';

// Holds an invite link's code across the login redirect within the tab; the web has no route params to carry it like the app.
export const savePendingReferralCode = (code: string) => {
  try {
    sessionStorage.setItem(PENDING_REFERRAL_CODE_KEY, code);
  } catch {
    // Storage unavailable: the code is only applied if the friend signs in without leaving the page.
  }
};

export const takePendingReferralCode = (): string | null => {
  try {
    const code = sessionStorage.getItem(PENDING_REFERRAL_CODE_KEY);

    sessionStorage.removeItem(PENDING_REFERRAL_CODE_KEY);

    return code;
  } catch {
    return null;
  }
};
